// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("images/success.png", import.meta.url);
// Module
var code = `<div class="rb-dialog rb-notification working"> <button class="close" ng-click="VM.cancel()"><i class="material-icons">close</i></button> <div class="header"> <div class="icon"> <img src="${___HTML_LOADER_IMPORT_0___}" alt="email" width="52px" height="52px"> </div> <div class="text"> <h3>Message</h3> <h1>Sent!</h1> </div> </div> </div> `;
// Exports
export default code;